/* =============================================================================
   Paradise Sorter
   Groups, sorting and the poof reveal. All visible cards animate on the same
   frame so the shelf appears out of a cloud together, and the reveal runs again
   whenever the group or the sort order changes.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pp-sorter]');
  if (!root) return;

  var grid = root.querySelector('[data-pp-grid]');
  var note = root.querySelector('[data-pp-note]');
  var sortEl = root.querySelector('[data-pp-sort]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pp-tab]'));
  var mores = Array.prototype.slice.call(root.querySelectorAll('[data-pp-more]'));
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-pp-item]'));
  if (!grid || !items.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = tabs.length ? tabs[0].getAttribute('data-pp-tab') : null;
  var revealed = false;
  var timer = null;

  root.classList.add('pp-sorter-ready');

  /* ------------------------------------------------------------- helpers */
  function meta(el) {
    return {
      el: el,
      group: el.getAttribute('data-group'),
      price: Number(el.getAttribute('data-price') || 0),
      title: (el.getAttribute('data-title') || '').toLowerCase(),
      available: el.getAttribute('data-available') === '1',
      order: Number(el.getAttribute('data-order') || 0)
    };
  }
  var models = items.map(meta);

  var COMPARE = {
    featured: function (a, b) {
      return a.order - b.order;
    },
    'price-asc': function (a, b) {
      return a.price - b.price || a.order - b.order;
    },
    'price-desc': function (a, b) {
      return b.price - a.price || a.order - b.order;
    },
    'name-asc': function (a, b) {
      return a.title.localeCompare(b.title);
    },
    'name-desc': function (a, b) {
      return b.title.localeCompare(a.title);
    },
    available: function (a, b) {
      return Number(b.available) - Number(a.available) || a.order - b.order;
    }
  };

  function label(group) {
    var tab = root.querySelector('[data-pp-tab="' + group + '"] .pp-tab-label');
    return tab ? tab.textContent.trim() : '';
  }

  /* -------------------------------------------------------------- render */
  function apply(animate) {
    var key = sortEl && COMPARE[sortEl.value] ? sortEl.value : 'featured';
    var visible = models.filter(function (m) {
      return !current || m.group === current;
    });
    visible.sort(COMPARE[key]);

    // Order first, then toggle visibility, so the browser lays the whole grid
    // out in a single pass and every card can start its reveal together.
    var frag = document.createDocumentFragment();
    visible.forEach(function (m) {
      m.el.hidden = false;
      m.el.classList.remove('is-poofing', 'is-shown');
      frag.appendChild(m.el);
    });
    models.forEach(function (m) {
      if (visible.indexOf(m) === -1) {
        m.el.hidden = true;
        m.el.classList.remove('is-poofing', 'is-shown');
      }
    });
    grid.appendChild(frag);

    mores.forEach(function (a) {
      a.hidden = a.getAttribute('data-pp-more') !== current;
    });

    if (note) {
      note.textContent = visible.length
        ? visible.length + ' pieces in ' + label(current)
        : 'Nothing in this group yet';
    }

    if (animate === 'idle') return;

    if (reduced) {
      visible.forEach(function (m) {
        m.el.classList.add('is-shown');
      });
      return;
    }

    // One shared frame for the whole shelf.
    clearTimeout(timer);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        visible.forEach(function (m) {
          m.el.classList.add('is-poofing', 'is-shown');
        });
      });
    });
  }

  /* -------------------------------------------------------------- events */
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var next = t.getAttribute('data-pp-tab');
      if (next === current) return;
      current = next;
      tabs.forEach(function (o) {
        var on = o === t;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      apply(revealed ? 'poof' : 'idle');
    });
  });

  if (sortEl) {
    sortEl.addEventListener('change', function () {
      apply(revealed ? 'poof' : 'idle');
    });
  }

  /* --------------------------------------------------------- first reveal */
  function first() {
    if (revealed) return;
    revealed = true;
    apply('poof');
  }

  // The resting state is laid out first, then the poof fires as the shelf
  // scrolls into view so the arrival reads as part of the page.
  apply('idle');

  if (reduced) {
    first();
  } else {
    // A measured scroll check rather than an IntersectionObserver. The theme
    // makes the body its own scroll container, which stops observer callbacks
    // from updating, so the shelf is measured directly instead.
    var ticking = false;
    function check() {
      ticking = false;
      var r = grid.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < h * 0.88 && r.bottom > 0) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        first();
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // The first measurement waits for the page to finish loading. Before then
    // the hero images have no intrinsic size, the document is short, and the
    // shelf would appear to be in view while it is still far below the fold.
    if (document.readyState === 'complete') check();
    else window.addEventListener('load', check);
    // A polled measurement as well as the scroll listener, so a theme that
    // scrolls inside its own container still reveals the shelf on arrival.
    var poll = setInterval(function () {
      if (revealed) clearInterval(poll);
      else check();
    }, 400);
    setTimeout(function () {
      clearInterval(poll);
    }, 120000);
  }
})();
